import type { FC } from 'react'
import { useState } from 'react'

import MetricSourceTestResults from './metricSourceTestResults'

import type { ButtonProps } from '@app/components/ui/button'
import { Button } from '@app/components/ui/button'
import { METRIC_SOURCES } from '@app/lib/globals'
import type { MetricSource, MetricSourceTestPayload } from '@graphql/queries'
import { useMetricSourceTestMutation } from '@graphql/queries'

interface TestMetricSourceButtonProps extends ButtonProps {
  metricSource?: Pick<MetricSource, 'id' | 'sourceName'> | null
}

const TestMetricSourceButton: FC<TestMetricSourceButtonProps> = ({ metricSource = undefined, ...buttonProps }) => {
  const [loading, setLoading] = useState(false)
  const [{ data: testData }, testQuery] = useMetricSourceTestMutation()
  const [open, setOpen] = useState(false)

  if (!metricSource || !METRIC_SOURCES[metricSource.sourceName].testable) {
    return null
  }

  const handleTest = () => {
    setLoading(true)
    testQuery({ input: { metricSourceId: metricSource.id } }).finally(() => {
      setLoading(false)
      setOpen(true)
    })
  }

  return (
    <>
      <MetricSourceTestResults
        testData={testData?.metricSourceTest as MetricSourceTestPayload}
        open={open}
        onClose={() => setOpen(false)}
      />
      <Button aria-label="Test metric source" loading={loading} onClick={handleTest} {...buttonProps}>
        Test connection
      </Button>
    </>
  )
}

export default TestMetricSourceButton
